import palette from "../theme/palette";

export const QuillCampaignStyle = {
  border: `1px solid ${palette.grey[500_32]}`,
  borderRadius: "8px",
  minHeight: "250px",
};
